import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import PurchaseFormErrorMessage from '../../common/forms/PurchaseFormErrorMessage';

export enum ErrorType {
  Blank = 'blank',
  Failed = 'failed',
  Taken = 'taken',
  Invalid = 'invalid',
}

type InnerProps = InjectedIntlProps;

const BlankMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.createUser.blank`,
      defaultMessage: intl.formatMessage({ id: 'purchases.errors.blank' }),
    })}
  </PurchaseFormErrorMessage>
);

const TakenMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.createUser.taken`,
      defaultMessage: intl.formatMessage({ id: 'purchases.errors.taken' }),
    })}
  </PurchaseFormErrorMessage>
);

const InvalidMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.createUser.invalid`,
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.invalid',
      }),
    })}
  </PurchaseFormErrorMessage>
);

const ERROR_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [error in ErrorType]: React.ComponentClass | undefined;
} = {
  [ErrorType.Blank]: injectIntl(BlankMessage),
  [ErrorType.Taken]: injectIntl(TakenMessage),
  [ErrorType.Invalid]: injectIntl(InvalidMessage),
  [ErrorType.Failed]: undefined,
};

interface Props {
  errors?: ErrorType[];
}

class ErrorMessage extends React.Component<Props> {
  public render() {
    const { errors } = this.props;
    if (!errors) {
      return null;
    }
    if (errors.length === 0) {
      return null;
    }
    return errors.map((error, index) => {
      const Component = ERROR_COMPONENTS[error];
      if (!Component) {
        return null;
      }
      return <Component key={index} />;
    });
  }
}

export default ErrorMessage;
